module.exports = __webpack_public_path__ + "static/media/journal_captured.c862f241.svg";